import { createFaviconUrl } from '@terminal/views/alfred/research/utils/createFaviconUrl';

export interface WebsiteInfo {
  id: string;
  title: string;
  url: string;
  favicon: string;
}

export const formatWebsiteInfo = (urls: string[]) =>
  urls.map(source => ({
    id: crypto.randomUUID(),
    title: '',
    url: source,
    favicon: createFaviconUrl(source, 24),
  }));
